@if (dynamicOptions.layers.length) {
<div class="map"
     leaflet
     id="leafletMap"
     [leafletOptions]="dynamicOptions">
</div>
} @else {
  Maps data not loaded yet.
}
